import SpektrixAPI from "../utils/SpektrixAPI";
import SpektrixGreeting from "./SpektrixGreeting.js";
import reset from "../utils/resetEvents.js";
import Cookies from "js-cookie";
import Disclosure from "../utils/Disclosure.js";

class InstanceDialog {
    constructor(element) {
        this.el = element;
        this.api = new SpektrixAPI();
        this.container = this.el.querySelector("#dialogLiveRegion");
        this.loginForm = this.el.querySelector("#dialogLoginForm");
        this.instancesLoggedIn = this.el.querySelector(
            "#dialogInstancesLoggedIn",
        );
        this.instancesLoggedOut = this.el.querySelector(
            "#dialogInstancesLoggedOut",
        );

        this.isPromoCodeApplied = false;

        this.init();
    }

    async init() {
        const isNonSpektrix = this.el.dataset.nonSpektrix === "1";

        if (isNonSpektrix) {
            this.template = this.instancesLoggedOut;
            this.attachTemplate();

            if (location.hash === "#bookings") {
                this.openViaBookingButton();
            }

            return;
        }

        this.customer = await this.getCustomer();

        if (this.customer?.id) {
            this.template = this.instancesLoggedIn;
        } else {
            this.template = this.instancesLoggedOut;
        }

        this.attachTemplate();

        document.addEventListener(
            "loginSuccess",
            this.handleLoginSuccess.bind(this),
        );

        if (location.hash === "#bookings") {
            this.openViaBookingButton();
        }

        this.createDisclosures();
    }

    openViaBookingButton() {
        // Trigger the dialog through the same click path as a "Book now"
        // button (wired up by Dialog.js) rather than calling showModal()
        // directly, so a direct #bookings link locks the background page
        // and shows/hides scrollbars identically to a manual open.
        const bookingButton = document.querySelector(
            '[data-dialog-open="performances"]',
        );

        if (bookingButton) {
            bookingButton.click();
        } else {
            this.el.showModal();
        }
    }

    createDisclosures() {
        const accessGroups = document
            .querySelectorAll(".access-group")
            .forEach((i) => {
                const disclosureItems = [];
                const items = i
                    .querySelectorAll(".access-group-item")
                    .forEach((item) => {
                        const accordionDisclosure = new Disclosure(item, {
                            on: {
                                expandbegin: () => {
                                    disclosureItems.forEach((disclosure) => {
                                        // console.log("disclosure", disclosure);
                                        // console.log(
                                        //     "accordionDisclosure",
                                        //     accordionDisclosure,
                                        // );

                                        if (
                                            disclosure !== accordionDisclosure
                                        ) {
                                            disclosure.collapse();
                                        }
                                    });
                                },
                            },
                        });

                        disclosureItems.push(accordionDisclosure);
                    });
                // console.log("items", disclosureItems);
            });
    }

    async getCustomer() {
        let sessionCookieData = Cookies.get("spektrix_session");
        sessionCookieData = sessionCookieData
            ? JSON.parse(sessionCookieData)
            : {};

        if (!sessionCookieData.customer) {
            return false;
        }

        return sessionCookieData;
    }

    attachTemplate() {
        this.container.innerHTML = "";
        const clone = this.template.content.cloneNode(true);
        this.container.appendChild(clone);

        const allInstances = this.container.querySelectorAll("li[data-month]");
        if (allInstances.length <= 10) {
            allInstances.forEach((el) => (el.style.display = ""));
            const filters = this.container.querySelector("[instance-filters]");
            if (filters) filters.remove();
        }

        document.getElementById("instance-scroll-btn").style.display = allInstances >= 10 ? "" : "none";

        let event_slug = document.querySelector("[data-event-slug]");
        event_slug = event_slug?.dataset.eventSlug || "";

        this.is_member =
            this.customer?.priority_events?.includes(event_slug) || false;

        const member_welcomes =
            this.container.querySelectorAll("[member-welcome]");
        const guest_welcomes =
            this.container.querySelectorAll("[guest-welcome]");

        if (this.is_member) {
            guest_welcomes.forEach((welcome) => {
                welcome.hidden = true;
                welcome.style.display = "none";
            });
        } else {
            member_welcomes.forEach((welcome) => {
                welcome.hidden = true;
                welcome.style.display = "none";
            });
        }

        const promoCodeContainer =
            this.container.querySelector("[guest-welcome]");
        if (this.isPromoCodeApplied && promoCodeContainer) {
            promoCodeContainer.style.display = "none";
        }

        const firstNameContainers = this.container.querySelectorAll(
            "[customer-first-name]",
        );
        firstNameContainers.forEach((container) => {
            container.textContent = this.customer?.firstName || "";
        });

        const timeContainers = this.container.querySelectorAll("[time-of-day]");
        const time = SpektrixGreeting.getTimeOfDay();
        timeContainers.forEach((container) => {
            container.textContent = time;
        });

        const skipButton = this.container.querySelector("[skip-login]");
        if (skipButton) {
            skipButton.addEventListener("click", () => this.skipLogin());
        }

        const openLoginForm = this.container.querySelector("[open-login-form]");
        if (openLoginForm) {
            openLoginForm.addEventListener("click", () => this.openLoginForm());
        }

        const instanceFilters =
            this.container.querySelector("[instance-filters]");
        if (instanceFilters) {
            instanceFilters.querySelectorAll("button").forEach((el) => {
                el.addEventListener(
                    "click",
                    this.handleFilterInstances.bind(this),
                );
            });

            const activeButton = instanceFilters.querySelector("button.active");
            if (activeButton) {
                const month = activeButton.dataset.value;
                this.filterInstances(month);
            }
        }

        // const disclosures = reset.refreshDisclosures(this.el);
        // disclosures.forEach((item) => {
        //     let el = [...item.triggerElements][0];
        //     el.addEventListener("click", () => {
        //         disclosures.forEach((disclosure) => {
        //             disclosure.collapse();
        //         });
        //     });
        // });

        this.promoCodeForm = this.el.querySelector("#priority-promo-code");
        this.promoCodeForm?.addEventListener(
            "submit",
            this.promoCode.bind(this),
        );

        this.promoCodeFormLoggedout = this.el.querySelector(
            "#priority-promo-code-loggedout",
        );
        this.promoCodeFormLoggedout?.addEventListener(
            "submit",
            this.promoCodeLoggedout.bind(this),
        );
    }

    skipLogin() {
        this.template = this.instancesLoggedOut;
        this.attachTemplate();
    }

    openLoginForm() {
        this.template = this.loginForm;
        this.attachTemplate();
    }

    async handleLoginSuccess(event) {
        let interval = setInterval(async () => {
            this.customer = await this.getCustomer();
            if (this.customer?.id) {
                clearInterval(interval);
                this.template = this.instancesLoggedIn;
                this.attachTemplate();
            }
        }, 500);
    }

    handleFilterInstances(e) {
        let button = e.currentTarget;
        let month = button.dataset.value;

        if (button.classList.contains("active")) {
            month = false;
            button.classList.remove("active");
        } else {
            this.container
                .querySelectorAll("[instance-filters] button")
                .forEach((item) => {
                    item.classList.remove("active");
                });
            button.classList.add("active");
        }

        this.filterInstances(month);
    }

    filterInstances(month) {
        let counter = 0;
        document.querySelectorAll("[data-month]").forEach((el) => {
            el.style.display =
                !month || el.dataset.month === month ? "" : "none";

            if(el.dataset.month === month) {
                counter += el.querySelectorAll('li').length
            }
        });

        document.getElementById("instance-scroll-btn").style.display = counter >= 10 ? "" : "none";
    }

    async promoCode(e) {
        e.preventDefault();

        let form = e.currentTarget;
        let code = form.querySelector("#promo-code-input").value;
        form.querySelector(".error-message")?.remove();

        this.customer = await this.getCustomer();

        if (code) {
            let result = await this.api.request("/basket", "PATCH", {
                PromoCode: code,
            });

            if (result.promoCode) {
                let event_slug = document.querySelector("[data-event-slug]");
                event_slug = event_slug?.dataset.eventSlug || "";

                if (!Array.isArray(this.customer.priority_events)) {
                    this.customer.priority_events = this.customer.priority_events
                        ? [this.customer.priority_events]
                        : [];
                }
                
                if (!this.customer.priority_events.includes(event_slug)) {
                    this.customer.priority_events.push(event_slug);
                }

                Cookies.set("spektrix_session", JSON.stringify(this.customer));

                this.template = this.instancesLoggedIn;
                this.attachTemplate();
            } else {
                let el = document.createElement("p");
                el.classList.add("error-message");
                el.textContent = "Please enter a valid code";
                form.appendChild(el);
            }
        }
    }

    async promoCodeLoggedout(e) {
        e.preventDefault();

        let form = e.currentTarget;
        let code = form.querySelector("#promo-code-input-loggedout").value;
        form.querySelector(".error-message")?.remove();

        if (code) {
            let result = await this.api.request("/basket", "PATCH", {
                PromoCode: code,
            });

            if (result.promoCode) {
                this.isPromoCodeApplied = true;

                let event_slug = document.querySelector("[data-event-slug]");
                event_slug = event_slug?.dataset.eventSlug || "";

                let fakeCustomer = { priority_events: [event_slug] };
                Cookies.set("spektrix_session", JSON.stringify(fakeCustomer));

                this.template = this.instancesLoggedOut;
                this.attachTemplate();
            } else {
                let el = document.createElement("p");
                el.classList.add("error-message");
                el.textContent = "Please enter a valid code";
                form.appendChild(el);
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector("[data-dialog='performances']");
    if (!element) return;

    new InstanceDialog(element);
});

export default InstanceDialog;
